module.exports = __webpack_public_path__ + "static/img/unit_bg_all.bbf4d9db.jpg";